import React, { forwardRef } from 'react';
const Icon = forwardRef(function Button({ component, testId = 'store-icon', ...otherProps }, ref) {
    return (React.createElement("span", Object.assign({ ref: ref, "data-store-icon": true, "data-testid": testId }, otherProps), component));
});
export default Icon;
//# sourceMappingURL=Icon.js.map